import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { reactSelectStyles, reactSelectComponents } from 'src/features/_shared/styles/react-select.styles';
import { CustomerWorkoutSessionCreateSetFormData } from '../beans/customer.workout.session.create.form.data';
import moment from 'moment';
import { ProgramSession, ProgramSessionCreateRequest, ProgramSessionSetCreateRequest, ProgramSessionSetStatusEnum, Session, SetTransitByExerciseRequest, User } from 'src/api/entities';
import { FormManager } from 'src/_shared/managers/form.manager';
import { NavigationManager } from 'src/_shared/managers/navigation.manager';
import { PopupManager } from 'src/_shared/managers/popup.manager';
import { QueueManager } from 'src/_shared/managers/queue.manager';
import { TranslatorManager } from 'src/_shared/managers/TranslatorManager';
import { WorkoutManager } from 'src/_shared/managers/workout.manager';
import { WorkoutSessionManager } from 'src/_shared/managers/workout.session.manager';
import { WorkoutSessionSetManager } from 'src/_shared/managers/workout.session.set.manager';
import { WorkoutSetManager } from 'src/_shared/managers/workout.set.manager';
import { RouteEnum } from 'src/_shared/routes';
import { store } from 'src/_shared/store/configure';
import { useStoreSelector } from 'src/_shared/store/hook';
import { WorkoutSession } from 'src/api/entities/workout-session';
import { PopupType } from 'src/features/_shared/components/Popup/popup.item';
import {
    WorkoutSessionCreateUpdate,
    setWorkoutSessionItems,
    setWorkoutSessionItem,
    setWorkoutSessionSetItems,
    setSelectedWorkoutItem,
    setSelectedWorkoutSessionDate,
    resetWorkoutSessionCreateUpdate,
    setAvailableWorkoutItems,
} from 'src/features/workout/store/workout.session.slice';
import { Button } from 'src/features/_shared/components/Button/button.component';
import { WorkoutSessionSetTransitManager } from 'src/_shared/managers/workout.session.set.transit.manager';
import { PageTransition } from 'src/features/_shared/components/PageTransition/page.transition.component';

export const SessionsView: React.FC = () => {
    const translator = TranslatorManager.getInstance();
    const navigationManager = NavigationManager.getInstance();
    const queueManager = QueueManager.getInstance();
    const workoutManager = WorkoutManager.getInstance();
    const workoutSetManager = WorkoutSetManager.getInstance();
    const workoutSessionManager = WorkoutSessionManager.getInstance();
    const workoutSessionSetManager = WorkoutSessionSetManager.getInstance();
    const workoutSessionSetTransitManager = WorkoutSessionSetTransitManager.getInstance();
    const notificationManager = PopupManager.getInstance();

    const workoutSessions: WorkoutSession[] = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessions);
    const availableWorkouts: Session[] = useStoreSelector(state => state.reducer.workoutSessionSlice.availableWorkouts);
    const workoutSessionCreateUpdate: WorkoutSessionCreateUpdate = useStoreSelector(state => state.reducer.workoutSessionSlice.workoutSessionCreateUpdate);
    const customerItem: User = useStoreSelector(state => state.reducer.customerSlice.customer);
    interface SelectableWorkout {
        label: string;
        value: number;
    }
    const [availableWorkoutTitles, setAvailableWorkoutTitles] = useState<SelectableWorkout[]>([]);
    const [selectedDate, setSelectedDate] = useState<string>('');

    const getWorkoutSessions = async () => {
        const value = (await workoutSessionManager.search(customerItem.id)).data!;
        console.log(value);
        store.dispatch(setWorkoutSessionItems({ value }));
    };

    const getWorkouts = async () => {
        const response = (await workoutManager.search(customerItem.id)).data!;
        console.log(response);
        store.dispatch(setAvailableWorkoutItems({ response }));
        const selectableWorkouts: SelectableWorkout[] = [];
        response.forEach(work => {
            const selectableWorkout: SelectableWorkout = {
                label: work.title!,
                value: work.id!,
            };
            selectableWorkouts.push(selectableWorkout);
        });
        setAvailableWorkoutTitles(selectableWorkouts);
    };

    const handleCreateWorkoutSession = async () => {
        console.log(customerItem);
        console.log(workoutSessionCreateUpdate);
        console.log(selectedDate);
        const request: ProgramSessionCreateRequest = {
            data: {
                author: {
                    id: customerItem.id!,
                    name: customerItem.username,
                },
                details: {
                    date: workoutSessionCreateFormData.getValues('sessionDate'),
                    id: workoutSessionCreateFormData.getValues('sessionID'),
                    name: availableWorkoutTitles.find(sex => sex.value == workoutSessionCreateFormData.getValues('sessionID'))?.label,
                },
            },
        };
        if (workoutSessionCreateUpdate.selectedWorkout != undefined && workoutSessionCreateUpdate.selectedWorkout.id! != undefined) {
            const programSession: ProgramSession = await workoutSessionManager.create(request);
            const workoutSets = (await workoutSetManager.search(workoutSessionCreateFormData.getValues('sessionID'))).data;
            if (workoutSets != undefined && workoutSets.length > 0) {
                workoutSets.forEach(workoutSet => {
                    const workoutSetCreating: ProgramSessionSetCreateRequest = {
                        sessionID: programSession.id!,
                        authorId: customerItem.id!,
                        authorName: customerItem.username,
                        status: ProgramSessionSetStatusEnum.Done,
                        data: {
                            details: {
                                date: programSession.sessionDate,
                                exercise: {
                                    group: workoutSet.exerciseGroup,
                                    name: workoutSet.exerciseName,
                                    uuid: workoutSet.exerciseUuid,
                                },
                                reps: workoutSet.reps,
                                rest: workoutSet.rest,
                                weight: workoutSet.weight,
                                rir: workoutSet.rir,
                                rpe: workoutSet.rpe,
                            },
                        },
                    };
                    workoutSessionSetManager.create(programSession.id!, workoutSetCreating);
                });
                const transitRequest: SetTransitByExerciseRequest = {
                    sessionID: programSession.id,
                    authorID: customerItem.id!,
                };
                workoutSessionSetTransitManager.transitBySession(transitRequest);
            }
        }
    };

    useEffect(() => {
        getWorkoutSessions();
        getWorkouts();
    }, []);

    const handleWorkoutSessionDetail = async (workoutID: number) => {
        const getWorkoutData = async () => {
            const response = await workoutSessionManager.getById(workoutID);
            store.dispatch(setWorkoutSessionItem({ response }));
            console.log(workoutID);
            console.log(response.id!);
            if (response != undefined) {
                const sets = (await workoutSessionSetManager.search(workoutID)).data;
                if (sets != undefined) {
                    store.dispatch(setWorkoutSessionSetItems({ sets }));
                }
            }
        };
        await getWorkoutData();
        navigationManager.navigateTo(RouteEnum.workoutSessionsSets);
    };

    const handleSelectWorkout = async (choice: number) => {
        const value = await workoutManager.getById(choice);
        store.dispatch(setSelectedWorkoutItem({ value }));
        console.log(workoutSessionCreateUpdate.selectedWorkout);
    };

    const handleWorkoutSessionDelete = async (workoutSessionID: number) => {
        await workoutSessionManager.delete(workoutSessionID);
        getWorkoutSessions();
        getWorkouts();
    };

    const handleSetDate = (date: any) => {
        const value = date as string;
        store.dispatch(setSelectedWorkoutSessionDate({ value }));
        console.log(value);
        setSelectedDate(value);
        console.log(selectedDate);
    };

    const resetCustomerCreateUpdateForm = () => {
        store.dispatch(resetWorkoutSessionCreateUpdate());
    };

    const workoutSessionCreateFormData = FormManager.getInstance().buildFormProxy<CustomerWorkoutSessionCreateSetFormData>(
        CustomerWorkoutSessionCreateSetFormData,
        handleCreateWorkoutSession,
        {
            sessionDate: workoutSessionCreateUpdate.sessionDate,
            sessionID: workoutSessionCreateUpdate.selectedWorkout != undefined ? workoutSessionCreateUpdate.selectedWorkout.id : 0,
        },
        'onChange',
    );

    const handleStartCreate = () => {
        notificationManager.show({
            title: 'Nuova seduta',
            type: PopupType.Info,
            icon: 'bi-calendar-check-fill',
            children: (
                <div className='App mt-2'>
                    <div className='col'>
                        <div className='d-flex justify-content-between mb-3' style={{ gap: 10 }}>
                            <div>
                                <input
                                    id='startDate'
                                    className='form-control'
                                    type='date'
                                    {...workoutSessionCreateFormData.register('sessionDate')}
                                    onChange={event => {
                                        workoutSessionCreateFormData.setValue('sessionDate', event.target.value as string);
                                        console.log(workoutSessionCreateFormData.getValues('sessionDate'));
                                        handleSetDate(event.target.value as string);
                                    }}
                                />
                            </div>
                            <div className='text-start'>
                                <Select
                                    styles={reactSelectStyles}
                                    components={reactSelectComponents}
                                    id='workout'
                                    options={availableWorkoutTitles}
                                    {...workoutSessionCreateFormData.register('sessionID')}
                                    placeholder='Seleziona un workout'
                                    onChange={(choice: SelectableWorkout) => {
                                        console.log('choiceID', choice.value!);
                                        workoutSessionCreateFormData.setValue('sessionID', choice.value!);
                                        console.log(workoutSessionCreateFormData.getValues('sessionID'));
                                        handleSelectWorkout(choice.value!);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ),
            ctas: {
                primary: {
                    cta: async () => {
                        await handleCreateWorkoutSession(), await getWorkoutSessions();
                    },
                },
                secondary: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
                close: {
                    cta: () => {
                        resetCustomerCreateUpdateForm();
                    },
                },
            },
        });
    };

    return (
        <PageTransition className='mt-4 px-3 px-md-4'>
            {/* ── Page Header ──────────────────────────────────────────── */}
            <div
                className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4 p-4 anim-slide-up'
                style={{
                    background: 'linear-gradient(135deg, #fff 0%, #fafafa 100%)',
                    borderRadius: 12,
                    border: '1px solid rgba(0,0,0,0.06)',
                }}>
                <div>
                    <div className='d-flex align-items-center gap-2 mb-1'>
                        <i className='bi bi-calendar3' style={{ fontSize: '1.4rem', color: '#ff4949' }}></i>
                        <h4 className='mb-0 fw-bold' style={{ color: '#333' }}>{customerItem.username}</h4>
                    </div>
                    <p className='mb-0 mt-1' style={{ color: '#666', fontSize: '0.9rem' }}>
                        <span className='badge rounded-pill me-2' style={{ backgroundColor: '#ff4949', color: '#fff', fontSize: '0.8rem' }}>
                            {availableWorkouts !== undefined ? availableWorkouts.length : 0}
                        </span>
                        protocolli associati
                    </p>
                </div>
                <div className='mt-3 mt-md-0'>
                    <Button
                        identifier='Nuova seduta'
                        icon={<i className='bi bi-plus-lg' style={{ fontSize: '0.9rem', color: 'white' }}></i>}
                        variant='primary'
                        onClick={() => handleStartCreate()}
                    />
                </div>
            </div>

            {/* ── Session List ─────────────────────────────────────────── */}
            {workoutSessions.length > 0 ? (
                <div className='d-flex flex-column gap-3 mb-4'>
                    {workoutSessions.map((workoutSession: ProgramSession, index: number) => (
                        <div
                            key={workoutSession.id}
                            className='app-card anim-stagger'
                            style={{
                                '--anim-index': index,
                                borderLeft: '3px solid #ff4949',
                                padding: 0,
                                overflow: 'hidden',
                            } as React.CSSProperties}>
                            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between p-3'>
                                <div className='d-flex align-items-center gap-3 mb-2 mb-md-0'>
                                    <i className='bi bi-calendar2-check' style={{ fontSize: '1.1rem', color: '#ff4949' }}></i>
                                    <div>
                                        <h6 className='mb-0 fw-bold' style={{ color: '#333' }}>{workoutSession.sessionName}</h6>
                                        <span style={{ fontSize: '0.8rem', color: '#999' }}>
                                            {`Creato il ${moment(workoutSession.sessionDate).format('D MMMM YYYY')}`}
                                        </span>
                                    </div>
                                </div>
                                <div className='d-flex gap-2'>
                                    <Button identifier='Dettagli' variant='primary' onClick={() => handleWorkoutSessionDetail(workoutSession.id!)} />
                                    <Button identifier='Elimina' variant='secondary' onClick={() => handleWorkoutSessionDelete(workoutSession.id!)} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div
                    className='text-center p-5 anim-slide-up'
                    style={{
                        backgroundColor: '#f9f9f9',
                        borderRadius: 10,
                        border: '1px solid rgba(0,0,0,0.06)',
                    }}>
                    <i className='bi bi-calendar-x' style={{ fontSize: '2rem', color: '#ccc' }}></i>
                    <p className='mb-0 mt-2' style={{ color: '#999', fontSize: '0.9rem' }}>Nessuna seduta registrata</p>
                </div>
            )}
        </PageTransition>
    );
};
